import { useQuery } from '@tanstack/react-query';
import { getForm30Dashboard, Form30DashboardResponse } from '../../services/network/form30-api';
import { useEffect, useState } from 'react';

interface UseFetchForm30DashboardParams {
    year: number | null;
    table_id: string | null;
    row_id: string | null;
    column_key: string | null;
}

export const useFetchForm30Dashboard = ({
    year,
    table_id,
    row_id,
    column_key
}: UseFetchForm30DashboardParams) => {
    const [shouldFetch, setShouldFetch] = useState(false);

    // Проверяем готовность всех параметров
    useEffect(() => {
        if (year && table_id && row_id && column_key) {
            setShouldFetch(true);
        } else {
            setShouldFetch(false);
        }
    }, [year, table_id, row_id, column_key]);

    const { data, isLoading, isError, error, refetch } = useQuery<Form30DashboardResponse>({
        queryKey: ['form30Dashboard', year, table_id, row_id, column_key],
        queryFn: async () => {
            if (!year || !table_id || !row_id || !column_key) {
                throw new Error('Отсутствуют обязательные параметры');
            }
            return await getForm30Dashboard(year, table_id, row_id, column_key);
        },
        enabled: shouldFetch,
        staleTime: 5 * 60 * 1000, // 5 минут
        retry: 2,
    });

    return {
        dashboardData: data?.data || [],
        isLoading,
        isError,
        error,
        refetch
    };
};
